import { render, staticRenderFns } from "./RsaSchedaPazienteComponent.vue?vue&type=template&id=c174d30a&scoped=true"
import script from "./RsaSchedaPazienteComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaPazienteComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaPazienteComponent.vue?vue&type=style&index=0&id=c174d30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c174d30a",
  null
  
)

export default component.exports